import api from './api';

export const getInvoiceSummary = () =>
  api.get('/api/v1/invoices/summary').then((r) => r.data.data);

export const getInvoices = (params) =>
  api.get('/api/v1/invoices', { params }).then((r) => r.data.data);

export const getInvoice = (id) =>
  api.get(`/api/v1/invoices/${id}`).then((r) => r.data.data);

export const createInvoice = (data) =>
  api.post('/api/v1/invoices', data).then((r) => r.data.data);

export const updateInvoice = (id, data) =>
  api.put(`/api/v1/invoices/${id}`, data).then((r) => r.data.data);

export const recordPayment = (id, data) =>
  api.post(`/api/v1/invoices/${id}/payments`, data).then((r) => r.data.data);

export const chargeCard = (id) =>
  api.post(`/api/v1/invoices/${id}/charge-card`).then((r) => r.data);

export const createAchIntent = (id) =>
  api.post(`/api/v1/invoices/${id}/ach-intent`).then((r) => r.data);

export const deleteInvoice = (id) =>
  api.delete(`/api/v1/invoices/${id}`).then((r) => r.data);

export const downloadSuperbill = async (id, invoiceNumber) => {
  const response = await api.get(`/api/v1/invoices/${id}/superbill`, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `superbill-${invoiceNumber}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};
